import { NavBar,HeroSection } from "components";
export default function LandingPage() {
	return (
		<div className='bg-white h-screen'>
			<NavBar />
			<HeroSection />
		</div>
	);
}
